import {Outlet} from "react-router-dom";

const FavoriteItems = () => {
  return <Outlet/>
}

export default FavoriteItems;